import { spinnerTypes } from './types';

const show = () => {
	return {
		type: spinnerTypes.SHOW,
	};
};

const hide = () => {
	return {
		type: spinnerTypes.HIDE
	};
};

export const spinnerActions = {
	show,
	hide
};